var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandbookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 105,
    viewBox: "0 0 84 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M75.3328 1.68753V42.0409H71.9741V1.68753C71.9741 0.737272 72.7442 0 73.6617 0C73.76 0 73.8419 -3.05173e-08 73.9402 0.0327676C74.743 0.147454 75.3328 0.851959 75.3328 1.68753Z",
    fill: "#DC4453"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M80.6904 104.857V87.8176H8.55232C3.83377 87.8176 0.0327148 91.6351 0.0327148 96.3372C0.0327148 96.5011 0.0327144 96.6813 0.0490983 96.8287C0.180169 98.9914 1.09767 100.941 2.50668 102.383C4.06314 103.907 6.19304 104.857 8.55232 104.857H80.6904Z",
    fill: "#5D9BEC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M80.6742 87.8337V104.857H13.1235V103.153H78.6754V87.8337H80.6742Z",
    fill: "#4B89DC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.1235 87.834V104.857H8.53598C6.19309 104.857 4.04681 103.923 2.50673 102.366C2.37566 102.235 2.26097 102.088 2.1299 101.941C0.917495 100.564 0.163838 98.7948 0.0327676 96.8124C-3.05173e-08 96.6649 0 96.4847 0 96.3208C0 91.6351 3.81744 87.8176 8.5196 87.8176H13.1235V87.834Z",
    fill: "#646D78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.1235 103.153V104.857H8.53597C6.19308 104.857 4.0468 103.923 2.50671 102.366C2.37564 102.235 2.26095 102.088 2.12988 101.94C3.40782 102.71 4.91514 103.153 6.53714 103.153H13.1235Z",
    fill: "#434A54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M80.6904 100.663V87.8176H12.255C8.71608 87.8176 5.83252 90.7012 5.83252 94.2401C5.83252 96.0096 6.55341 97.6316 7.71666 98.7948C8.87992 99.9581 10.4692 100.679 12.255 100.679H80.6904V100.663Z",
    fill: "#E7E9EE"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M83.9999 83.9345V8.61787C83.9999 6.47158 82.2632 4.71851 80.1005 4.71851H15.4827C6.9467 4.71851 0.0327148 11.6325 0.0327148 20.1521V96.3371C0.0327148 91.635 3.85015 87.8175 8.55231 87.8175H80.1005C82.2468 87.8175 83.9999 86.0808 83.9999 83.9345Z",
    fill: "#5D9BEC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M83.9837 8.61825V83.9349C83.9837 86.0811 82.2634 87.8342 80.0843 87.8342H13.1235V84.1315H77.4301C79.5928 84.1315 81.3295 82.3784 81.3295 80.2321V4.93188C82.886 5.43978 83.9837 6.89795 83.9837 8.61825Z",
    fill: "#4B89DC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M19.9393 46.3664C19.5133 46.3664 19.1528 46.0223 19.1528 45.58V14.3687C19.1528 13.9427 19.4969 13.5823 19.9393 13.5823C20.3652 13.5823 20.7257 13.9263 20.7257 14.3687V45.5964C20.7257 46.0223 20.3816 46.3664 19.9393 46.3664Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.1234 4.93188V87.8342H8.53594C6.19305 87.8342 4.04676 88.8008 2.52306 90.3245C2.32646 90.5211 2.14623 90.7177 1.98239 90.9143C1.96601 90.9307 1.96601 90.9307 1.96601 90.9307C1.6711 91.2748 1.42534 91.6188 1.22874 92.0121C0.851907 92.6346 0.556998 93.29 0.360392 94.0109C0.131018 94.7482 0.0327148 95.5182 0.0327148 96.321V20.1525C0.0327148 19.1695 0.114634 18.2356 0.278473 17.3181C0.327625 17.0887 0.376776 16.8757 0.425927 16.6463C0.475079 16.4006 0.524231 16.1712 0.60615 15.9582C0.688069 15.7616 0.737221 15.5322 0.802756 15.3192C0.884676 15.0735 0.982979 14.8441 1.04851 14.5984C1.37619 13.7792 1.7694 12.9764 2.21177 12.2391C3.37502 10.3222 4.94787 8.6674 6.79925 7.38946C7.91335 6.65219 9.10938 6.0296 10.4201 5.57085C11.3048 5.27595 12.1895 5.04657 13.1234 4.93188Z",
    fill: "#646D78"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M53.7891 3.52253C53.7891 1.57285 55.3619 0 57.3116 0H73.6627C72.7452 0 71.9752 0.753658 71.9752 1.68754V33.9965L63.7341 28.6062L53.7891 33.9965V3.52253Z",
    fill: "#ED5463"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M68.7629 45.3504V55.2627C68.7629 55.8853 68.2714 56.3932 67.6488 56.3932H29.4745C28.8519 56.3932 28.3604 55.8853 28.3604 55.2627V45.3504C28.3604 44.7442 28.8519 44.2363 29.4745 44.2363H67.6488C68.2714 44.2363 68.7629 44.7442 68.7629 45.3504Z",
    fill: "#F6F7FA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M68.7629 45.3504V55.2627C68.7629 55.8853 68.2714 56.3932 67.6488 56.3932H29.4745C28.8683 56.3932 28.3767 55.9016 28.3604 55.2954H66.42C67.0426 55.2954 67.5341 54.7875 67.5341 54.165V44.2363H67.6488C68.2714 44.2363 68.7629 44.7442 68.7629 45.3504Z",
    fill: "#E7E9EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M28.3604 60.8987H68.7629V62.6681H28.3604V60.8987Z",
    fill: "#F6F7FA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M28.3604 65.3225H56.983V67.092H28.3604V65.3225Z",
    fill: "#F6F7FA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M60.6523 65.3225H67.0093V67.092H60.6523V65.3225Z",
    fill: "#F6F7FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandbookIcon);
export default __webpack_public_path__ + "static/media/HandbookIcon.7221ba3ec2403ecfa53eb572bbcab9a5.svg";
export { ForwardRef as ReactComponent };